/**
 * 此组件封装页面尾部
 */
import React, { PureComponent } from 'react'
import './footer.scss'
import baseMethods from "../../../api/baseMethods";
import { Link, withRouter } from 'react-router-dom';
import main_routes_all from "../../../router/main_routes_all";
import { withTranslation } from 'react-i18next';

class Footer extends PureComponent {
    /*跳转到商品详情*/
    constructor(props) {
        super(props);
        this.state = {};
    }

    go_to_commo_details = (commo_id) => {
        let target_url = main_routes_all.pages.commodityTemplate + '?commodity_uuid=' + commo_id;
        this.props.history.push(target_url);
    };

    render() {
        const { t } = this.props;
        return (
            <div className='footer_bottom_all'>
                <div className='footer_bottom_box'>
                    <div className='footer_left_txt'>
                        <div className='footer_hot_service'>
                            <p className='hot_service_title'>{t('footer_hot_service')}</p>
                            <p className='hot_service_item '
                                onClick={this.go_to_commo_details.bind(this, 'c50b5653f51d4cfea3d39f288013608a')}>
                                {t('footer_integrated_service')}
                            </p>
                            <p className='hot_service_item '
                                onClick={this.go_to_commo_details.bind(this, 'c65ff031c94e405faf79428eec631045')}>
                                {t('footer_interactive_connection')}
                            </p>
                            <p className='hot_service_item '
                                onClick={this.go_to_commo_details.bind(this, 'd94f205e194546f3a27b8954b9c2aa51')}>
                                {t('footer_cloud_cutting')}
                            </p>
                        </div>
                        <div className='footer_hot_service'>
                            <p className='hot_service_title'>{t('footer_friendly_link')}</p>
                            <p className='hot_service_item '>
                                <a target="view_window"
                                    href='http://www.sobey.com/'>{t('footer_Sobey_official_web')}</a>
                            </p>
                        </div>
                        <div className='footer_hot_service'>
                            <p className='hot_service_title'>{t('footer_about_Sobey')}</p>
                            <p className='hot_service_item '>
                                <a target="view_window"
                                    href='http://www.sobey.com/index.php?m=content&c=index&a=lists&catid=1'>{t('footer_Sobey_intro')}</a>
                            </p>
                            <p className='hot_service_item '>
                                <Link to='/contactus'>{t('footer_contact_us')}</Link>
                            </p>
                        </div>
                    </div>
                    <div className='footer_right_qrcode'>
                        <div className='right_qrcode_down'>
                            <p className='qrcode_down_txt company'>{t('footer_chengdu_Sobey')}</p>
                            <p className='qrcode_down_txt su-icp'>
                                {t('footer_filing_num')}
                                <a href='https://beian.miit.gov.cn/' target='_blank'
                                    rel="noopener noreferrer">{t('footer_f_num_chuan')}</a>
                            </p>
                            <p className='qrcode_down_txt '>Copyright©Sobey. All rights reserved</p>
                        </div>
                        <div className='right_qrcode_up'>
                            <div className="qrcode_box">
                                <img className="qrcode_img" src={baseMethods.base_images_Url.img1} alt="Group2" />
                                <p className="qrcode_txt">{t('footer_sobey_weibo')}</p>
                            </div>
                            <div className="qrcode_box">
                                <img className="qrcode_img" src={baseMethods.base_images_Url.img2} alt="Group2" />
                                <p className="qrcode_txt">{t('footer_sobey_wechat')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/view/components/footer/footer.js